[
  {
    "code": "BE-BRU",
    "name": "Bruxelles-Capitale, Région de"
  },
  {
    "code": "BE-VLG",
    "name": "Vlaamse Gewest"
  },
  {
    "code": "BE-WAL",
    "name": "Wallonne, Région"
  }
]